import React, { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ChatbotWidget from "../chatbot/ChatbotWidget";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isFullWidthRoute =
    location.pathname === "/" ||
    location.pathname === "/trainings/full-stack" ||
    location.pathname.startsWith("/services") ||
    location.pathname.startsWith("/resources") ||
    location.pathname.startsWith("/marketplace") ||
    location.pathname.startsWith("/trainings");

  const mainClasses = isFullWidthRoute
    ? "flex-grow w-full max-w-[100vw] overflow-x-hidden relative z-0"
    : "flex-grow px-4 sm:px-6 md:px-8 py-4 md:py-6 w-full max-w-[100vw] overflow-x-hidden";

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className={`${mainClasses} flex flex-col`}>
        <div className="flex-grow">{children}</div>
      </main>
      <Footer />
      <ChatbotWidget />
    </div>
  );
};

export default Layout;
